export default "__VITE_ASSET__B28Xr3YP__"